module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sakSettings":"Account settings","change password":"Change password","setup MFA":"Multi factor authentication"},"de":{"sakSettings":"Zugangseinstellungen","change password":"Passwort ändern","setup MFA":"Multi Faktor Authentifizierung"}}')
  delete Component.options._Ctor
}
